import {ExternalLinksHandlersFactory} from "../../external-links-handlers-factory";
import {
    IRegistrationExternalLinkHandler
} from "../../../handlers/registration/registration.external-link-handler.interface";
import {
    NetherlandsRegistrationExternalLinkHandler
} from "../../../handlers/registration/regulations/netherlands/netherlands.registration.external-link-handler";
import {
    IMyAccountUploadDocumentsExternalLinkHandler
} from "../../../handlers/my-account-upload-documents/my-account-upload-documents.external-link-handler.interface";
import {
    NetherlandsMyAccountUploadDocumentsExternalLinkHandler
} from "../../../handlers/my-account-upload-documents/regulations/netherlands/netherlands.my-account-upload-documents.external-link-handler";
import {
    IPendingActionExternalLinkHandler
} from "../../../handlers/pending-action/pending-action.external-link-handler.interface";
import {
    NetherlandsRealGamePlayPendingActionExternalLinkHandler
} from "../../../handlers/pending-action/real-game-play/netherlands/netherlands.real-game-play-pending-action.external-link-handler";
import {
    IOpenRealGamePlayPendingActionOptions
} from "../../../handlers/pending-action/real-game-play/real-game-play-pending-action.external-link-handler.interface";

export class NetherlandsExternalLinksHandlersFactory extends ExternalLinksHandlersFactory {
    get registration(): IRegistrationExternalLinkHandler {
        return new NetherlandsRegistrationExternalLinkHandler(this.services);
    }

    get realGamePlayPendingAction(): IPendingActionExternalLinkHandler<IOpenRealGamePlayPendingActionOptions> {
        return new NetherlandsRealGamePlayPendingActionExternalLinkHandler(this.services);
    }

    get myAccountUploadDocuments(): IMyAccountUploadDocumentsExternalLinkHandler {
        return new NetherlandsMyAccountUploadDocumentsExternalLinkHandler(this.services)
    }
}